import { getCookieByName, setCookie } from "./cookies"

const getClientTimezone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone ||'UTC';
}

export const setTimezoneInCookies = () => {
    const hasTimezoneBeenSet = !!getCookieByName('timezone');
    const clientTimezone = getClientTimezone();
    setCookie('timezone', clientTimezone);

    // trigger page reload with if timezone was not set
    if (!hasTimezoneBeenSet) {
        window.location = window.location.href;
    }
}
